import moment from 'moment';
import { parseInt as _parseInt, isNaN as _isNaN } from 'lodash';

// A moment, a Date, an ISO-8601 string or an epoch (seconds or ms, number or
// numeric string) to a moment; anything else comes back unchanged. The one
// parser the display pipes share.
export const tryParseToMoment = (value: any): any => {
    if (moment.isMoment(value)) {
        return value;
    } else if (Object.prototype.toString.call(value) === '[object Date]') {
        return moment(value);
    } else {
        // ISO-8601 strings must be tried BEFORE the epoch fallback —
        // _parseInt('2026-07-13…') reads the leading year digits as an
        // epoch and lands in 1970. Strict parsing keeps plain numeric
        // strings on the epoch path.
        const iso = moment(value, moment.ISO_8601, true);
        if (iso.isValid()) {
            return iso;
        }
        let int = _parseInt(value);
        if (!_isNaN(int)) {
            if (int < 10000000000) {
                int = int * 1000;
            }
            return moment(int);
        }
    }
    return value;
};

export class FormatDateTimePipe {
    protected defaultFormat = 'D MMM YYYY HH:mm:ss';
    protected formatMoment(momentObj: moment.Moment, ...args: any[]) {
        return momentObj.format(args[0] || this.defaultFormat);
    }
}
